import { marked } from 'marked'
import TurndownService from 'turndown'

// Configure marked for safe HTML output
marked.setOptions({
  breaks: true,
  gfm: true,
})

// Create turndown service for HTML to markdown conversion
const turndownService = new TurndownService({
  headingStyle: 'atx',
  codeBlockStyle: 'fenced',
})

/**
 * Convert markdown to HTML
 */
export const markdownToHtml = (markdown: string): string => {
  return marked.parse(markdown) as string
}

/**
 * Convert HTML to markdown
 */
export const htmlToMarkdown = (html: string): string => {
  return turndownService.turndown(html)
}
